<template>
  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
  >
    <template #create-body>
      <update @refetchData="refetchData" />
    </template>

    <template #cell(value)="{ data }">
      <span v-if="data.item.key === 'MONITORING_ON_OF'">
        {{ data.value === '200' ? 'Faol emas' : 'Faol' }}
      </span>
      <span v-else>
        {{ data.value }}
      </span>
    </template>

    <!-- Column: Actions -->
    <template #cell(actions)="{ data }">

      <div class="text-nowrap">
        <feather-icon
          v-if="$can('manage', 'All')"
          v-b-toggle.sidebar-update-settings
          icon="EditIcon"
          class="cursor-pointer"
          size="16"
          @click="update(data.item)"
        />
      </div>
    </template>
  </l-table>

</template>

<script>
import {
  VBToggle,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import settingsModule from '@/store/settings/index'
import Update from './Update.vue'
import LTable from '@/views/components/LTable.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    LTable,
    Update,
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME}/FRESH`)
  },
  methods: {
    update(data) {
      this.$store.commit(`${this.MODULE_NAME}/UPDATE`, data)
    },
    refetchData() {
      this.$refs.LTable.refetchData()
    },
  },
  setup() {
    const MODULE_NAME = 'settings'

    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, settingsModule)

    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    return {
      MODULE_NAME,
      ...config(),
    }
  },
}
</script>

<style lang="scss">
</style>
